module.exports = __webpack_public_path__ + "view/img/swiper3.ac9d5a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiper3.png
// module id = g+bV
// module chunks = 1